import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { loadTags } from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var BusinessSalesComponent = /** @class */ (function () {
    function BusinessSalesComponent(_toggleService, _editSalesCheckboxDialog, snackBar, _businessManagerService) {
        var _this = this;
        this._toggleService = _toggleService;
        this._editSalesCheckboxDialog = _editSalesCheckboxDialog;
        this.snackBar = snackBar;
        this._businessManagerService = _businessManagerService;
        this.aircraftSalesTypesTags = [];
        this.aircraftTags = [];
        this.avionicsTags = [];
        this.editModeSet = false;
        this.isRegionalManager = false;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    }
    BusinessSalesComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loadAllTags();
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 1:
                        _b = (_c.sent());
                        if (!_b) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 2:
                        _b = !(_c.sent());
                        _c.label = 3;
                    case 3:
                        _a.isRegionalManager = _b;
                        return [2 /*return*/];
                }
            });
        });
    };
    BusinessSalesComponent.prototype.loadAllTags = function () {
        this.aircraftSalesTypesTags = loadTags(this.business.tags, 'Sales::Types::', '', '');
        this.aircraftTags = loadTags(this.business.tags, 'Sales::Aircraft::', '', '');
        this.avionicsTags = loadTags(this.business.tags, 'Sales::Avionics::', '', '');
    };
    Object.defineProperty(BusinessSalesComponent.prototype, "hasContent", {
        get: function () {
            return (this.aircraftSalesTypesTags.length > 0 || this.aircraftTags.length > 0 || this.avionicsTags.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    BusinessSalesComponent.prototype.openEditSalesDialog = function (group, except, title) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            business: this.business,
            tagsGroup: group,
            except: except,
            title: title
        };
        dialogConfig.width = '95%';
        var dialogRef = this._editSalesCheckboxDialog.open(EditTagsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isSuccess) {
            if (isSuccess) {
                _this.loadAllTags();
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return BusinessSalesComponent;
}());
export { BusinessSalesComponent };
